import React from "react";
import { Button, ButtonToolbar, Glyphicon, ListGroupItem } from "react-bootstrap";
import { LASTNAME_RU, NAME_RU } from "../../constants";

const ParticipantListItem = (
    {
        member,
        onEdit,
        onDelete,
        children,
    }
) => {
    return (
        <ListGroupItem
            style={{
                padding: '4px 4px 4px 12px',
                display: 'flex',
                justifyContent:'space-between',
                alignItems: 'center',
            }}
        >
            <div style={{display: 'flex', columnGap: '20px'}}>
                <span style={{fontWeight: 'bold'}}>
                    {member?.member?.[LASTNAME_RU]} {member?.member?.[NAME_RU]} 
                </span>
                {children}
            </div>
            <ButtonToolbar>
                <Button onClick={() => onEdit(member)}>
                    <Glyphicon glyph="pencil" />
                </Button>
                <Button onClick={() => onDelete(member.id)}>
                    <Glyphicon glyph="trash" />
                </Button>
            </ButtonToolbar>
        </ListGroupItem>
    );
};

export default ParticipantListItem;
